import classNames from 'classnames';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import styles from './CardsGrid.module.css';

interface Item {
  id: number | string;
}

interface Props<T extends Item = any> extends ComponentPropsWithoutRef<'div'> {
  items: T[];
  render(item: T, index: number): ReactNode;
  listClassName?: string;
  itemClassName?: string;
  className?: string;
}

const CardsGrid = ({
  items = [],
  render = () => null,
  listClassName = '',
  itemClassName = '',
  className,
  ...props
}: Props): ReactNode => (
  <div className={classNames(styles.component, className)} {...props}>
    <ul className={classNames(styles.list, listClassName)}>
      {items.map((item, index) => (
        <li key={item.id} className={classNames(styles.item, itemClassName)}>
          {render(item, index)}
        </li>
      ))}
    </ul>
  </div>
);

export default CardsGrid;
